import React, { Dispatch, SetStateAction } from "react";

import Grid from "@mui/material/Grid";
import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FiEyeOff, FiEye } from "react-icons/fi";
import { HiChevronDoubleUp, HiOutlineChevronDoubleDown } from "react-icons/hi";

import { useVideoSurveyInventory } from "../../../../hooks/useVideoSurveyInventory";
import useSurveyStyles from "../styles";
import MainHeader from "./MainHeader";
import useStyles from "./styles";
import TabHeader from "./TabHeader";

interface Props {
  roomSectionCollapsed: boolean;
  setRoomSectionCollapsed: Dispatch<SetStateAction<boolean>>;
  tabSectionCollapsed: boolean;
  setTabSectionCollapsed: Dispatch<SetStateAction<boolean>>;
  setCurrentTab: (value: number) => void;
}

const Header = ({
  roomSectionCollapsed,
  setRoomSectionCollapsed,
  tabSectionCollapsed,
  setTabSectionCollapsed,
  setCurrentTab,
}: Props) => {
  const classes = useStyles();
  const surveyClasses = useSurveyStyles();
  const { t: translate } = useTranslation();

  const { isInventoryCollapsed, setIsInventoryCollapsed } = useVideoSurveyInventory();

  const toggleHiddenSection = (
    isCollapsed: boolean,
    setIsCollapsed: Dispatch<SetStateAction<boolean>>,
    showText: boolean
  ) => {
    return (
      <div
        data-cy="collapseSection"
        onClick={() => setIsCollapsed((state) => !state)}
        className={surveyClasses.toggleHidden}
      >
        {isCollapsed ? <FiEye /> : <FiEyeOff />}
        {showText ? (
          <span>{isCollapsed ? translate("showSection") : translate("hideSection")}</span>
        ) : null}
      </div>
    );
  };

  const renderExpandAllPanels = () => {
    if (!roomSectionCollapsed) {
      return (
        <div data-cy="expandOrCollapse">
          <span>
            {isInventoryCollapsed ? translate("collapseAllPanels") : translate("expandAllPanels")}
          </span>
          <IconButton
            disabled={roomSectionCollapsed}
            onClick={() => {
              if (roomSectionCollapsed) return;

              setIsInventoryCollapsed((state) => !state);
            }}
          >
            {isInventoryCollapsed ? (
              <HiChevronDoubleUp size={15} color="#475467" />
            ) : (
              <HiOutlineChevronDoubleDown size={15} color="#475467" />
            )}
          </IconButton>
        </div>
      );
    }

    return null;
  };

  return (
    <Grid item xs={12} container direction="row">
      <Grid item xs={5}>
        <div className={classes.headerConsultant}>
          <MainHeader />
        </div>
      </Grid>

      <Grid item xs={4}>
        <div
          className={
            roomSectionCollapsed ? classes.headerInventoryCollapsed : classes.headerInventory
          }
        >
          <div className={classes.inventoryHeader}>
            {toggleHiddenSection(roomSectionCollapsed, setRoomSectionCollapsed, true)}

            {renderExpandAllPanels()}
          </div>
        </div>
      </Grid>

      <Grid item xs={3}>
        <div className={tabSectionCollapsed ? classes.tabsHeaderCollapsed : classes.tabsHeader}>
          <TabHeader
            toggle={tabSectionCollapsed}
            actions={(value, index) => {
              if (index !== undefined) setCurrentTab(index);
              else setCurrentTab(0);
              setTabSectionCollapsed(value);
            }}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default Header;
